/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_05_Detail_Beginner_2_HeadingInputs */

const en_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What to practice`)
};

const es_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qué practicar`)
};

const de_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was man üben sollte`)
};

const zh_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该练什么`)
};

const ar_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ما تتدرب عليه`)
};

const fr_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que pratiquer`)
};

const vi_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luyện gì`)
};

const sw_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nini cha kufanyia mazoezi`)
};

const th_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ควรซ้อมอะไร`)
};

const bs_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Šta vježbati`)
};

const ja_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`何を練習するか`)
};

const ko_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무엇을 연습할까`)
};

const pt_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que treinar`)
};

const it_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Su che cosa allenarti`)
};

const sv_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vad du ska träna på`)
};

const nl_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat je oefent`)
};

const da_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad du skal træne`)
};

const nb_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hva du bør øve på`)
};

const fi_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mitä harjoitella`)
};

const pl_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co ćwiczyć`)
};

const ru_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Что тренировать`)
};

const tr_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne çalışmalı`)
};

const hi_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`क्या अभ्यास करें`)
};

const id_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang perlu dilatih`)
};

const ms_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apa yang perlu dilatih`)
};

const cs_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co trénovat`)
};

const el_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τι να εξασκήσετε`)
};

const he_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה לתרגל`)
};

const af_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat om te oefen`)
};

const hu_method_content_step_05_detail_beginner_2_heading = /** @type {(inputs: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mit gyakorolj`)
};

/**
* | output |
* | --- |
* | "What to practice" |
*
* @param {Method_Content_Step_05_Detail_Beginner_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_05_detail_beginner_2_heading = /** @type {((inputs?: Method_Content_Step_05_Detail_Beginner_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_05_Detail_Beginner_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "de") return de_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "th") return th_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "it") return it_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "da") return da_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "id") return id_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "el") return el_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "he") return he_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "af") return af_method_content_step_05_detail_beginner_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_05_detail_beginner_2_heading(inputs)
	return en_method_content_step_05_detail_beginner_2_heading(inputs)
});